import { findQuestionOptionDetailsById } from 'gql/query'
// import { paperQuestionsDemo1,paperQuestionsDemo2,paperQuestionsDemo3,paperQuestionsDemo4,paperQuestionsDemo5,paperQuestionsDemo6 } from './customDataForTest'

interface IqstnResponse {
  mark?: number
}

export const candidateResponseByAnswers = async (candidateRespone: any, answersKey: any, totalMarkForPaper:any) => {
  try {
    const mostWrong: IqstnResponse = {}
    const closeToCorrect: IqstnResponse = {}
    const blankResponse:IqstnResponse={}
    const candidateQuestionDetails: any[] = []
    for (let i = 0; i <= answersKey.length - 1; i++) {
      let responseDbOptionDetails: any = await findQuestionOptionDetailsById(answersKey[i]?.id)
      let optionDetails = responseDbOptionDetails.questions[0]
      optionDetails.Qnum = answersKey[i]?.number
      await candidateQuestionDetails.push(optionDetails)
    }
   
    const wrongResponseOfUserQstn = await candidateRespone.filter((item: any) => item?.status !== 'correct')
    wrongResponseOfUserQstn.forEach((response: any) => {
      // const questionDetails = paperQuestionsDemo6.find(q => q.Qnum === response.key)
      const questionDetails = candidateQuestionDetails.find(q => q.Qnum === response.key)

      if (questionDetails) {
        //finding option based Index
        const optionIndex = response.value.charCodeAt(0) - 'A'.charCodeAt(0)

        if (optionIndex >= 0 && optionIndex < questionDetails.option_details.length) {
          const option = questionDetails.option_details[optionIndex]

          if (option.option_flag === 'Close to Correct') {
            closeToCorrect.mark = (closeToCorrect.mark || 0) + response.mark
          } else if (option.option_flag === 'Most Wrong') {
            mostWrong.mark = (mostWrong.mark || 0) + response.mark
          }else{
            blankResponse.mark=(blankResponse.mark || 0) + response.mark
          }
        }
      }
    })
    const percentageOfMostWrong = mostWrong?.mark? mostWrong?.mark/totalMarkForPaper*100 : 0;
    const percentageOfCloseToCorrect = closeToCorrect?.mark? closeToCorrect?.mark/totalMarkForPaper*100:0;
    const percentageOfBlankResponse = blankResponse?.mark? blankResponse?.mark/totalMarkForPaper*100:0;
    // console.log(percentageOfMostWrong, ':mostWrong', percentageOfCloseToCorrect, ': close to correct',percentageOfBlankResponse,":blank response")
    return {percentageOfMostWrong,percentageOfCloseToCorrect,percentageOfBlankResponse}
  } catch (err) {
    console.log(err)  
  }
}
